import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';

const NavBar = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const handleScroll = useCallback(() => {
    if (window.scrollY > lastScrollY && window.scrollY > 100) {
      setIsVisible(false);
    } else {
      setIsVisible(true);
    }
    setLastScrollY(window.scrollY);
  }, [lastScrollY]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY && window.scrollY > 100) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 bg-white shadow transition-transform duration-300 ease-in-out ${isVisible ? 'translate-y-0' : '-translate-y-full'}`}>
      <div className="container mx-auto px-4 py-2 flex justify-start items-center">
        {/* Navigation links with logo */}
        <div className="flex items-center space-x-8">
          <Link to="/">
            <img src="/images/tm-white-on-teal.png" alt="TravelMaker Logo" className="h-10 rounded-lg" />
          </Link>
          <Link to="/" className="text-lg font-medium text-teal-600 transition-colors duration-300 hover:text-teal-700">
            Home
          </Link>
          <Link to="/trips" className="text-lg font-medium text-teal-600 transition-colors duration-300 hover:text-teal-700">
            Trips
          </Link>
          <Link to="/blog" className="text-lg font-medium text-teal-600 transition-colors duration-300 hover:text-teal-700">
            Blog
          </Link>
          <Link to="/partners" className="text-lg font-medium text-teal-600 transition-colors duration-300 hover:text-teal-700">
            Partners
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
